import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import HowItWorks from "@/pages/HowItWorks";
import ServiceArea from "@/pages/ServiceArea";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Booking from "@/pages/Booking";
import Manage from "@/pages/Manage";
import Gallery from "@/pages/Gallery";
import Reviews from "@/pages/Reviews";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Account from "@/pages/Account";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-lg flex-col items-center justify-center px-5 text-center">
      <h1 className="font-heading text-6xl font-extrabold tracking-tighter text-primary">404</h1>
      <p className="mt-4 text-lg text-muted-foreground">This page took the trash out and left.</p>
      <Link to="/" className="mt-8 inline-flex rounded-xl bg-primary px-7 py-3.5 font-bold text-primary-foreground transition-all hover:-translate-y-0.5 hover:brightness-110">
        Back Home
      </Link>
    </div>
  );
}

function App() {
  useEffect(() => {
    if (localStorage.getItem("rmb_theme") === "dark") {
      document.documentElement.classList.add("dark");
    }
  }, []);

  return (
    <div className="App">
      <Toaster position="bottom-right" richColors />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
            <Route path="/how-it-works" element={<PublicLayout><HowItWorks /></PublicLayout>} />
            <Route path="/service-area" element={<PublicLayout><ServiceArea /></PublicLayout>} />
            <Route path="/gallery" element={<PublicLayout><Gallery /></PublicLayout>} />
            <Route path="/reviews" element={<PublicLayout><Reviews /></PublicLayout>} />
            <Route path="/faq" element={<PublicLayout><FAQ /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
            <Route path="/booking" element={<PublicLayout><Booking /></PublicLayout>} />
            <Route path="/manage" element={<PublicLayout><Manage /></PublicLayout>} />
            <Route path="/login" element={<PublicLayout><Login /></PublicLayout>} />
            <Route path="/signup" element={<PublicLayout><Signup /></PublicLayout>} />
            <Route path="/account" element={<PublicLayout><Account /></PublicLayout>} />
            <Route path="/payment/success" element={<PublicLayout><PaymentSuccess /></PublicLayout>} />
            <Route path="/payment/cancel" element={<PublicLayout><PaymentCancel /></PublicLayout>} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/book" element={<PublicLayout><Booking /></PublicLayout>} />
            <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
